import * as React from 'react';

export function useMenu() {
  const triggerId = React.useId();
  const menuId = React.useId();

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  function close() {
    setAnchorEl(null);
  }

  function open(element: HTMLElement) {
    setAnchorEl(element);
  }

  function getTriggerProps() {
    return {
      id: triggerId,
      'aria-controls': anchorEl ? menuId : undefined,
      'aria-expanded': anchorEl ? 'true' : undefined,
      'aria-haspopup': 'true',
      onClick: (event: React.MouseEvent<HTMLElement>) =>
        setAnchorEl(event.currentTarget),
    } as const;
  }

  function getMenuProps() {
    return {
      id: menuId,
      open: Boolean(anchorEl),
      onClose: close,
      anchorEl: anchorEl,
      MenuListProps: { 'aria-labelledby': triggerId },
    } as const;
  }

  return {
    anchorEl,
    close,
    getMenuProps,
    getTriggerProps,
    isOpen: anchorEl !== null,
    menuId,
    open,
    triggerId,
  };
}
